"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/web.dom.iterable");require("core-js/modules/es6.number.constructor"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default =
{
  name: 'CodeTree',
  props: {
    protocolId: {
      type: Number } },


  data: function data() {
    return {
      protocolCodeList: [], // 列表数据
      defaultCheckCode: [],
      handleCheckList: [],
      handleAllList: [],
      radio: '',
      addData: {
        id: '',
        name: '' },

      defaultProps: {
        children: 'children',
        label: 'label' } };


  },
  mounted: function mounted() {
    var self = this;
    self.init(self.protocolId);
  },
  methods: {
    init: function init(id) {
      var self = this;
      self.handleCheckList = [];
      var path = '/api/deviceModelProtocol/' + id + '/usedtree';
      self.getData(path, self.searchData, function (res) {
        self.protocolCodeList = res;
        for (var i = 0; i <= res.length; i++) {
          self.defaultCheckCode.push(res[i].id);
        }
        res.forEach(function (c) {return self.handleAllList.push(c.id);});
      });
    },
    handleCheckChange: function handleCheckChange(data, checked, indeterminate) {
      var self = this;
      if (checked) {
        self.handleCheckList.push(data.id);
      } else {
        self.handleDelCheckCode(data.id, self.handleCheckList);
      }
      var diff = self.handleCheckList.filter(function (check) {return self.handleAllList.indexOf(check) === -1;});
      self.handleCheckList = diff;
      console.log('handleList', self.handleCheckList);
    },
    handleAllChange: function handleAllChange(val) {
      var self = this;
      if (val === 1) {
        self.handleCheckList = [];
        self.protocolCodeList.forEach(function (code) {
          code.children.forEach(function (child) {return self.handleCheckList.push(child.id);});
        });
      } else if (val === 2) {
        self.handleCheckList = [];
      } else if (val === 3) {
        var allList = [];
        self.protocolCodeList.forEach(function (code) {
          code.children.forEach(function (child) {return allList.push(child.id);});
        });
        var diff = allList.filter(function (code) {return self.handleCheckList.indexOf(code) === -1;});
        self.handleCheckList = diff;
      }
      self.$refs.orgTree.setCheckedKeys(self.handleCheckList);
      self.protocolCodeList.forEach(function (code) {
        self.handleDelCheckCode(code.id, self.handleCheckList);
      });
    },
    handleDelCheckCode: function handleDelCheckCode(str, arr) {
      var index = arr.indexOf(str);
      arr.splice(index, 1);
    } } };exports.default = _default;